export const getEnv = (key, defaultValue = '') => {
  return (
    (window._env_ && window._env_[key]) || process.env[key] || defaultValue
  );
};

export const notEmpty = (value) => !isEmpty(value);

export const isEmpty = (value) => {
  // null or undefined
  if (value == null) return true;

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  // Date (treat invalid date as empty, optional)
  if (value instanceof Date) {
    return isNaN(value.getTime());
  }

  // object (but not Date, Map, Set)
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  // numbers, booleans, functions, symbols → NOT empty
  return false;
};

export const isTrue = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    return ['true', 'yes', '1', 't'].includes(value.trim().toLowerCase());
  }
  return false;
};

/**
 * Use explicit check instead of just !isTrue to avoid 'null' being 'false'
 */
export const isFalse = (value) => {
  if (typeof value === 'boolean') return value === false;
  if (typeof value === 'number') return value === 0;
  if (typeof value === 'string') {
    return ['false', 'no', '0', 'f'].includes(value.trim().toLowerCase());
  }
  return false;
};
